module.exports = __webpack_public_path__ + "static/media/pc.331ac8d9.png";